// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify, {
  VApp,
  VBtn,
  VParallax,
  VForm,
  VRow,
  VCol,
  VTextField,
  VTextarea,
  Carousele,
  ExpansionPanel,
  VMenu,
  VList,
  VListItem,
  VListItemTitle,
  VListItemContent,
  VIcon,
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  icons: {
    iconfont: 'mdi',
  },
  components: {
    VApp,
    VBtn,
    VParallax,
    VForm,
    VRow,
    VCol,
    VTextField,
    VTextarea,
    Carousele,
    ExpansionPanel,
    VMenu,
    VList,
    VListItem,
    VListItemTitle,
    VListItemContent,
    VIcon,
  },
  directives: {
    Ripple,
  },
})

export default new Vuetify()
